<ng-container *ngIf="!isLoading else loading">
    <fieldset>
        <legend>Theme Configuration</legend>
        <div class="theme-config">
            <label class="required"><b>Label Name</b></label>
            <div class="form-inline labels mt-3">
                <div class="label-name" *ngFor="let label of allLabelsArray">
                    <input type="radio" class="hide" [id]="label.id" [(ngModel)]="selectedLabel" name="label"
                        [value]="label.name" (change)="onLabelChange()">
                    <label [for]="label.id" class="button">{{label.name}}
                        <span class="check-icon" *ngIf="label.isAssetsUploaded"></span>
                    </label>
                </div>
            </div>

            <div *ngIf="selectedLabel">
                <ng-container *ngIf="isWABFeature">
                    <div class="whack-a-bingo">
                        <fieldset class="ms-2 mt-2">
                            <legend>Set Intro Text and Colours</legend>
                            <div class="intro-text-container">
                                <div class="me-3">
                                    <label for="intro-text" class="me-2 required"><b>Intro Text</b></label>
                                    <input type="text" class="form-control" style="width:400px"
                                        [class.is-valid]="introText != ''" [class.is-invalid]="introText == ''"
                                        placeholder="Enter Intro Text here" [(ngModel)]="introText"
                                        (blur)="updateIntroText()" pattern="^[A-Za-z0-9 ]+$"
                                        oninput="validity.valid||(value='');" id="intro-text">
                                </div>
                                <div class="mt-3 mb-3">
                                    <strong><u>Note:</u> The Font color you have applied for "Intro Text" will be
                                        applicable on Winner window and Game Messages</strong>
                                </div>
                                <!-- <div class="d-flex align-items-center me-5">
                                    <div class="me-3">
                                        <label for="color" class="me-2 required"><b>Welcome Title Color</b></label>
                                        <input type="text" [(ngModel)]="labelColor.welcome_title" class="form-control"
                                            id="color" [class.is-invalid]="labelColor.welcome_title == ''" readonly>
                                    </div>
                                    <input type="color" class="mt-4" [(ngModel)]="labelColor.welcome_title">
                                </div>
                                <div class="d-flex align-items-center">
                                    <div class="me-3">
                                        <label for="color" class="me-2 required"><b>Table Header BG Color</b></label>
                                        <input type="text" [(ngModel)]="labelColor.table_header_bg" class="form-control"
                                            id="color" [class.is-invalid]="labelColor.table_header_bg == ''" readonly>
                                    </div>
                                    <input type="color" class="mt-4" [(ngModel)]="labelColor.table_header_bg">
                                </div> -->
                            </div>
                            <!-- <div class="intro-text-colour-container">
                                <div class="d-flex align-items-center">
                                    <div class="me-3">
                                        <label for="color" class="me-2 required"><b>Table Header Text Color</b></label>
                                        <input type="text" [(ngModel)]="labelColor.table_header_text"
                                            class="form-control" id="color"
                                            [class.is-invalid]="labelColor.table_header_text == ''" readonly>
                                    </div>
                                    <input type="color" class="mt-4" [(ngModel)]="labelColor.table_header_text">
                                </div>
                                <div class="d-flex align-items-center ms-5">
                                    <div class="me-3">
                                        <label for="color" class="me-2 required"><b>Table Row BG Color</b></label>
                                        <input type="text" [(ngModel)]="labelColor.table_row_bg" class="form-control"
                                            id="color" [class.is-invalid]="labelColor.table_row_bg == ''" readonly>
                                    </div>
                                    <input type="color" class="mt-4" [(ngModel)]="labelColor.table_row_bg">
                                </div>
                                <div class="d-flex align-items-center">
                                    <div class="me-3">
                                        <label for="color" class="me-2 required"><b>Table Row Text Color</b></label>
                                        <input type="text" [(ngModel)]="labelColor.table_row_text" class="form-control"
                                            id="color" [class.is-invalid]="labelColor.table_row_text == ''" readonly>
                                    </div>
                                    <input type="color" class="mt-4" [(ngModel)]="labelColor.table_row_text">
                                </div>
                            </div> -->
                            <div *ngIf="isLabelSelected else colorScrnLoading">
                                <app-whack-a-bingo-preview [gameAssets]="assetsInfo" [(txtColor)]="labelColor"
                                    [fontObj]="fontDataObj ?? {}" [selectedLabel]="selectedLabel"
                                    [on_points_info]="configObj.on_points" (confirmAssets)="OnPreviewConfirm($event)"
                                    [isDefaultPreview]="isDefPreview" [wabType]="featureType" [mode]="'editable'"
                                    (onSaveconfig)="onSaveColors($event)"></app-whack-a-bingo-preview>
                            </div>
                            <ng-template #colorScrnLoading>
                                <div class="text-center col-12">
                                    <img src="../../../../assets/images/rolling.gif" alt="loading" />
                                </div>
                            </ng-template>
                        </fieldset>
                        <fieldset class="ms-2 mt-2">
                            <legend>Set Fonts</legend>
                            <div class="fonts-container mb-0">
                                <div class="asset-type-section">
                                    <div class="each-type">
                                        <input type="radio" name="fontType" value="predefined"
                                            [(ngModel)]="fontDataObj.font_type" (click)="toggleFontTypeRadio($event)" />
                                        <label class="ms-3"><strong>Pre-defined Fonts</strong></label>
                                    </div>
                                    <div class="each-type ms-3">
                                        <input type="radio" name="fontType" value="custom"
                                            [(ngModel)]="fontDataObj.font_type" (click)="toggleFontTypeRadio($event)" />
                                        <label class="ms-3"><strong>Custom Fonts</strong></label>
                                    </div>
                                </div>
                            </div>
                            <div class="fonts-container mt-0 mb-4"
                                *ngIf="fontDataObj.font_type =='predefined' else elseBlock">
                                <div>
                                    <select style="width:200px" class="form-control" [(ngModel)]="selectedFont"
                                        (change)="onFontSelect($event)">
                                        <option value="" disabled>--Select Font--</option>
                                        <option *ngFor="let each of predefinedFontsList" [value]="each.font_name">
                                            {{each.font_name}}</option>
                                    </select>
                                </div>
                            </div>
                            <ng-template #elseBlock>
                                <div [hidden]="fontDataObj.font_type==''">
                                    <div class="row">
                                        <div class="col-6">
                                            <label class="label-fontsize" class="required">Upload Regular Font
                                                (woff/woff2) File</label>
                                            <input hidden class="ms-2" accept=".woff,.woff2" id="fontR"
                                                (change)="uploadAFile($event, {}, 'fonts', 'regular')" #fileInput1 type="file"
                                                name="Font File2">
                                            <span class="ms-2"><i class="pi pi-upload upload-icon"
                                                    (click)="fileInput1.click()"></i></span>
                                            <span *ngIf="fontDataObj?.font_info?.font_file_info?.regular?.file_path"
                                                class="ms-2 text-success"><b>{{getDisplayFileName($safeNavigationMigration(fontDataObj?.font_info?.font_file_info?.regular?.file_path))}}</b></span>
                                        </div>
                                        <div class="col-6">
                                            <label class="label-fontsize" class="required">Upload Bold Font
                                                (woff/woff2)
                                                File</label>
                                            <input hidden class="ms-2" accept=".woff,.woff2" id="fontB"
                                                (change)="uploadAFile($event, {}, 'fonts', 'bold')" #fileInput2 type="file"
                                                name="Font File1">
                                            <span class="ms-2"><i class="pi pi-upload upload-icon"
                                                    (click)="fileInput2.click()"></i></span>
                                            <span *ngIf="fontDataObj?.font_info?.font_file_info?.bold?.file_path"
                                                class="ms-2 text-success"><b>{{getDisplayFileName($safeNavigationMigration(fontDataObj?.font_info?.font_file_info?.bold?.file_path))}}</b></span>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </fieldset>
                    </div>
                </ng-container>
                <!-- <ng-container *ngIf="isWABFeature && !isWAB">
                    <div class="whack-a-bingo-chat">
                        <div class="me-3">
                            <label for="intro-text" class="me-2 required"><b>Intro Text</b></label>
                            <input type="text" style="height: 30px;width: 400px;" class="form-control"
                                [class.is-valid]="introText != ''" [class.is-invalid]="introText == ''"
                                placeholder="Enter Intro Text here" [(ngModel)]="introText" (blur)="updateIntroText()"
                                pattern="^[A-Za-z0-9 ]+$" oninput="validity.valid||(value='');" id="intro-text">
                        </div>
                        <div class="me-3">
                            <label for="color" class="me-2 required"><b>Color</b></label>
                            <input type="text" [(ngModel)]="labelColor" style="height: 30px;width: 400px;"
                                class="form-control" id="color" [class.is-invalid]="labelColor == ''" readonly>
                        </div>
                        <input type="color" class="mt-4" [(ngModel)]="labelColor" (change)="onColorChange()">
                    </div>
                </ng-container> -->
                <fieldset class="ms-2 mt-2">
                    <legend>Set Assets</legend>
                    <div class="asset-type-section">
                        <div class="each-type">
                            <input type="radio" name="assetType" value="defAssets" [(ngModel)]="selectedType"
                                (change)="onTypeChange()" />
                            <label class="ms-3"><strong>Default Assets</strong></label>
                        </div>
                        <div class="each-type ms-3">
                            <input type="radio" name="assetType" value="uploadAssets" [(ngModel)]="selectedType"
                                (change)="onTypeChange()" />
                            <label class="ms-3"><strong>Upload Assets</strong></label>
                        </div>
                    </div>

                    <div *ngIf="selectedType == 'defAssets'">
                        <div *ngFor="let type of objectKeys(assetsInfo)">
                            <fieldset class="mb-2">
                                <legend>Default <span class="text-capitalize">{{type}}</span></legend>
                                <table class="table vertical-align-middle">
                                    <tbody>
                                        <tr *ngFor="let each of assetsInfo[type]">
                                            <td class="col-7">
                                                <label class="label-fontsize">
                                                    <strong class="text-capitalize">
                                                        {{each.name}} {{type.slice(0, -1)}}
                                                    </strong>
                                                </label>
                                            </td>
                                            <td class="col-3" *ngIf="type != 'sounds'; else soundsBlock">
                                                <img *ngIf="each.defPath" [id]="each.val" class="media-file"
                                                    [alt]="each.name" width="50" height="50" [src]="each.defPath">
                                            </td>
                                            <ng-template #soundsBlock>
                                                <td class="col-3">
                                                    <audio *ngIf="each.defPath" [id]="each.val" controls=""
                                                        class="media-file" [src]="each.defPath"> Your browser does not
                                                        support the
                                                        <code>audio</code> element.
                                                    </audio>
                                                </td>
                                            </ng-template>
                                        </tr>
                                    </tbody>
                                </table>
                            </fieldset>
                        </div>
                        <div>
                            <button *ngIf="isPreviewFeature" class="gms-btn primary save-btn"
                                (click)="onPreview()">Preview</button>
                        </div>
                    </div>

                    <div *ngIf="selectedType == 'uploadAssets'">
                        <div class="text-danger">
                            <b>Note: </b>Image type accepted - png, Sound type accepted - mp3
                            (max size for both image and sound is 300KB) and save the assets before creating/editing the
                            feature.
                        </div>
                        <div *ngFor="let type of objectKeys(assetsInfo)">
                            <fieldset class="mt-2 mb-2">
                                <legend><span class="text-capitalize">{{type}}</span></legend>
                                <table class="table vertical-align-middle">
                                    <tbody>
                                        <tr *ngFor="let each of assetsInfo[type]">
                                            <td class="col-7">
                                                <label class="label-fontsize {{each.isRequired ? 'required' : ''}}">
                                                    <strong class="text-capitalize">
                                                        {{each.name}} {{type.slice(0, -1)}}
                                                    </strong>
                                                </label>
                                            </td>
                                            <ng-container *ngIf="type != 'sounds'; else soundsBlock">
                                                <td class="col-2">
                                                    <button (click)="imageInput.click()"
                                                        [disabled]="!name">Upload</button>
                                                    <input hidden [accept]="each.allowedTypes" #imageInput
                                                        id="{{each.val}}" type="file" required
                                                        (change)="uploadAFile($event, each, type)">
                                                </td>
                                                <td class="col-3">
                                                    <img *ngIf="each.path" [id]="each.val" class="media-file"
                                                        [alt]="each.name" width="50" height="50"
                                                        [src]="this.CmnServ.getSantizeUrl(each.path)">
                                                </td>
                                            </ng-container>
                                            <ng-template #soundsBlock>
                                                <td class="col-2">
                                                    <button (click)="soundInput.click()"
                                                        [disabled]="!name">Upload</button>
                                                    <input hidden [accept]="each.allowedTypes" #soundInput
                                                        id="{{each.val}}" type="file" required
                                                        (change)="uploadAFile($event, each, type)">
                                                </td>
                                                <td class="col-3">
                                                    <audio *ngIf="each.path" [id]="each.val" controls=""
                                                        class="media-file" [src]="CmnServ.getSantizeUrl(each.path)">
                                                        Your browser does not support the
                                                        <code>audio</code> element.
                                                    </audio>
                                                </td>
                                            </ng-template>
                                        </tr>
                                    </tbody>
                                </table>
                            </fieldset>
                        </div>
                        <div>
                            <div *ngIf="isPreviewFeature else saveBtn">
                                <div class="text-danger mb-3">
                                    <b>Note: </b>
                                    Please click on the preview button after uploading all required assets.
                                    Assets will be saved only after clicking on Save button available in Preview popup.
                                </div>

                                <button class="gms-btn primary save-btn" (click)="onPreview()"
                                    [disabled]="(!isReqAssetsUploaded() || !name)">Preview</button>
                            </div>
                            <ng-template #saveBtn>
                                <button class="gms-btn primary save-btn" (click)="saveMultimedia()"
                                    [disabled]="(!isReqAssetsUploaded() || !name)">Save</button>
                            </ng-template>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </fieldset>

    <!-- Preview -->

    <div class="modal-backdrop fade show" *ngIf="isPreviewEnabled"></div>
    <div *ngIf="isPreviewEnabled">
        <ng-container *ngIf="isWABFeature">
            <div class="wab-preview">
                <app-whack-a-bingo-preview [gameAssets]="assetsInfo" [txtColor]="labelColor"
                    [fontObj]="fontDataObj ?? {}" [selectedLabel]="selectedLabel" [on_points_info]="configObj.on_points"
                    (confirmAssets)="OnPreviewConfirm($event)" [isDefaultPreview]="isDefPreview" [wabType]="featureType"
                    [mode]="'preview'" (playSounds)="playWabSounds($event)"></app-whack-a-bingo-preview>
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-template #loading>
    <div class="text-center col-12">
        <img src="../../../../assets/images/rolling.gif" alt="loading" />
    </div>
</ng-template>